export default __webpack_public_path__ + "static/media/categoria.eceb51b9.jpeg";